<ion-app>
  <app-loader />
  <iam-content />
  <ion-router-outlet></ion-router-outlet>
</ion-app>
